<template>
	<div class="page1warp">
		<div class='ruleModule_warp'>
			<!-- <div class='rule_box'>
				<span> 章程详细内容请点击下载—></span>
				<span class='rule_title' @click="ruleFn">中国人才交流协会章程</span>
			</div> -->
			<div v-html="contentObj.content" class='ruleDetail_box'></div>
		</div>
	</div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
	data() {
		return {
			currentPage: 1,
			PageSize: 1,
			contentObj: {}

		}
	},
	mounted() {
		this.getNewsData()
	},
	methods: {
		async getNewsData() {
			let params = {
				pageSize: 4,
				pageCurrent: 1,
				pressSuperClass: "17",
			};
			let data = await httpService.getNewsList(params);
			if (data.code == 200) {
				if (data.result.list.length != 0) {
					let id = data.result.list[0].pressId
					this.getnewdetail(id)
				}
			}
		},
		async getnewdetail(id) {
			let data = await httpService.getNewsDetails(id);
			if (data.result) {
				this.contentObj = data.result
			}
		},
		// ruleFn() {
		// 	let url = '2021-05-31/150028-中国人才交流协会章程（2017年7月民政部核准后新增党建部分版）.pdf'
		// 	let Docurl = `http:${process.env.VUE_APP_GATEWAY}${'/upload/download?session='}${url}${'&fileName='}${'中国人才交流协会章程'}`
		// 	window.open(Docurl)
		// }
	}
}
</script>
<style lang="less" scoped>
.page1warp {
	width: 1160px;
	margin-top: 20px;
	.ruleModule_warp {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		padding: 20px;
		.rule_title {
			display: inline-block;
			cursor: pointer;
			font-weight: bold;
			width: 160px;
			padding-bottom: 4px;
			border-bottom: 1px solid #1890ff;
			color: #1890ff;
			margin-left: 10px;
		}
		.rule_box {
			// width: 400px;
			// margin: 20px auto;
			display: flex;
			flex-direction: row;
			font-size: 16px;
			color: #213959;
			// position: fixed;
			// height: 60px;
		}
		.ruleDetail_box {
			height: 560px;
		}
		overflow-y: scroll;
	}
}
</style>


